import { toneBadge } from "@/lib/statusTone";

const sizes = {
  /** The Knowledge gaps pill, for rail rows. */
  default: "min-w-5 px-1.5 py-0.5 text-xs",
  /** For the mode switcher's small tiles. */
  compact: "min-w-4 px-1 text-[10px] leading-4",
};

/**
 * The Inbox count pill, in the shape of the Knowledge gaps badge: attention
 * tone above zero, muted at zero, and nothing at all while the count is
 * unknown so a failed feed never looks like an empty inbox.
 */
export function InboxCountBadge({ count, size = "default", className = "" }: { count: number | null; size?: keyof typeof sizes; className?: string }) {
  if (count === null) return null;
  return <span aria-label={`${count} ${count === 1 ? "item" : "items"} waiting in the inbox`}
    className={`rounded-md border text-center tabular-nums ${sizes[size]} ${count > 0 ? toneBadge.attention : "border-transparent text-zinc-500"} ${className}`}>{count}</span>;
}
